module.exports = __webpack_public_path__ + "img/symbol-swan-left.28a34ce9.png";